import * as p from '@clack/prompts'
import type { ServicesPromptResult } from '@cli-types/next-adapter/init.js'
import { promptConnectionString } from './prompt-connection-string.js'

export async function promptServices(): Promise<ServicesPromptResult> {
  const choice = await p.select({
    message: 'Connect a PostgreSQL Database',
    options: [
      {
        value: 'vercel' as const,
        label: 'Vercel (Neon Postgres)',
        hint: 'Automatically provision a Neon Postgres database'
      },
      {
        value: 'railway' as const,
        label: 'Railway (Postgres)',
        hint: 'Provision Postgres in your Railway project'
      },
      {
        value: 'manual' as const,
        label: 'Manual',
        hint: 'Manually enter connection details'
      }
    ],
    initialValue: 'vercel' as const
  })

  if (p.isCancel(choice)) {
    p.cancel('Setup cancelled.')
    process.exit(0)
  }

  if (choice === 'vercel') {
    return { provider: 'vercel' }
  }

  if (choice === 'railway') {
    return { provider: 'railway' }
  }

  const url = await promptConnectionString()
  return { provider: 'manual', url }
}
